import { createFileRoute } from '@tanstack/react-router';
import { useProject } from '@/features/projects/use-project';
import { requireReportsFeature } from '@/features/reports/guard';
import { ReportList } from '@/features/reports/report-list';

/** REP-01: status reports of a project. */
export const Route = createFileRoute('/_app/p/$projectKey/reports/')({
  beforeLoad: ({ context }) => requireReportsFeature(context.queryClient),
  component: RouteComponent,
});

function RouteComponent() {
  const { projectKey } = Route.useParams();
  const project = useProject(projectKey);
  return <ReportList project={project} />;
}
